module.exports = __webpack_public_path__ + "static/img/003.6b3bf598.png";